import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=33244853&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"
import style0 from "./Orders.vue?vue&type=style&index=0&id=33244853&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33244853",
  null
  
)

export default component.exports